import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";

import { UserService } from "@services/user.service";
import { UiService } from "@services/ui.service";
import { UserParameter } from "@classes/user-parameter";

@Injectable()
export class ParametersResolver implements Resolve<UserParameter> {
    constructor(
        private userSrv: UserService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserParameter> {
        const localParams = this.userSrv.userParametersSubject.value;

        if(localParams) {
            return of(localParams);
        }

        // Else call API
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.userSrv.getParameters()
        .pipe(
            tap(userParameters => {
                this.uiSrv.routeLoadingStateChanged.next(false);

                return userParameters;
            }),
            catchError((err) => {
                return of(null);
            })
        );
    }
}
